import comm4 from './images/comm4.jpg';
import grid1 from './images/grid1.jpg';
import res1 from './images/res1.jpg';
import res4 from './images/res4.jpg';
import steel1 from './images/steel1.jpg';
import res2 from "./images/res2.jpg";

export const business = {
  name: 'KMK Drywall',
  phoneDisplay: '(716) 353-2989',
  phoneHref: 'tel:+17163532989',
  phoneSchema: '+1-716-353-2989',
  email: 'kmkdrywall8900@gmail.com',
  emailHref: 'mailto:kmkdrywall8900@gmail.com',
  city: 'Springville',
  region: 'NY',
  serviceArea: 'Buffalo, Erie County, and Western New York',
};

export const serviceAreas = [
  'Buffalo',
  'Erie County',
  'Western New York',
];

export const services = [
  {
    title: 'Residential Drywall',
    summary:
      'Clean drywall hanging, taping, finishing, and repair for remodels, additions, basements, and new homes.',
    image: res1,
    alt: 'Residential drywall installation and finishing work by KMK Drywall in Western New York',
  },
  {
    title: 'Commercial Drywall',
    summary:
      'Reliable commercial drywall installation and finishing for offices, retail build-outs, and larger interior projects.',
    image: comm4,
    alt: 'Commercial drywall and steel framing project in progress in Western New York',
  },
  {
    title: 'Steel Framing',
    summary:
      'Accurate metal stud framing for commercial interiors, walls, soffits, and build-outs that need a straight start.',
    image: steel1,
    alt: 'Steel framing installation for a commercial interior build-out',
  },
  {
    title: 'Ceiling Tile Grid',
    summary:
      'Acoustical ceiling grid and tile installation for polished, serviceable commercial ceilings.',
    image: grid1,
    alt: 'Commercial ceiling tile grid installation by KMK Drywall',
  },
  {
    title: 'Drywall Finishing',
    summary:
      'Smooth finishing, sanding, and detail work that gets walls ready for paint and final trim.',
    image: res4,
    alt: 'Finished residential drywall room with clean taping and sanding',
  },
  {
    title: 'Drywall Repair',
    summary:
      'Responsive drywall patching and repair for damaged walls, renovation tie-ins, and punch-list fixes.',
    image: res2,
    alt: 'Finished commercial interior with ceiling grid and drywall work',
  },
];

export const trustPoints = [
  'Fully insured',
  'Family-owned in Springville, NY',
  'Residential and commercial crews',
  'Serving Western New York',
];
